import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import MenuItems from './MenuItems';
import MenuItemsOnePage from './MenuItemsOnePage';
import Button from '../Button';

import Logo from '../../assets/img/logo/logo-black.png';
import LogoWhite from '../../assets/img/logo/logo-white-4.png';

const HeaderFour = (props) => {
  const { headerClass, headerLogo, isOnePage } = props;
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const [isCurrencyDropdownOpen, setIsCurrencyDropdownOpen] = useState(false);
  const languageRef = useRef(null);
  const currencyRef = useRef(null);

  // Handler to toggle Language dropdown
  const toggleLanguageDropdown = () => {
    setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
    setIsCurrencyDropdownOpen(false);
  };

  // Handler to toggle currency dropdown
  const toggleCurrencyDropdown = () => {
    setIsCurrencyDropdownOpen(!isCurrencyDropdownOpen);
    setIsLanguageDropdownOpen(false);
  };

  // Close the dropdown when clicking outside the button
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        languageRef.current &&
        !languageRef.current.contains(event.target) &&
        currencyRef.current &&
        !currencyRef.current.contains(event.target)
      ) {
        setIsLanguageDropdownOpen(false);
        setIsCurrencyDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [languageRef, currencyRef]);

  useEffect(() => {
    // Sticky Header is displayed after scrolling for 400 pixels
    const toggleVisibility = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <>
      <header className={headerClass ? headerClass : ''}>
        <div className="it-header-top-area it-header-top-style-2">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xxl-5 col-xl-4 col-lg-3 col-md-4">
                <div className="it-header-top__left d-flex align-items-center">
                  <div className="it-header-top__category-wrap d-none d-md-block">
                    <div
                      ref={languageRef}
                      className={
                        isLanguageDropdownOpen
                          ? 'it-header-top__category open'
                          : 'it-header-top__category'
                      }
                      onClick={() => toggleLanguageDropdown()}
                    >
                      <ul>
                        <li>
                          <a href="javascript:void(0)">
                            ENGLISH
                            <span className="ps-1">
                              <i className="fa-regular fa-angle-down"></i>
                            </span>
                          </a>
                          <ul className="it-header-top__category-submenu">
                            <li>
                              <a href="#">Arabic</a>
                            </li>
                            <li>
                              <a href="#">Spanish</a>
                            </li>
                            <li>
                              <a href="#">Mandarin</a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="it-header-top__area-wrap d-none d-md-block">
                    <div
                      ref={currencyRef}
                      className={
                        isCurrencyDropdownOpen
                          ? 'it-header-top__area open'
                          : 'it-header-top__area'
                      }
                      onClick={() => toggleCurrencyDropdown()}
                    >
                      <ul>
                        <li>
                          <a href="javascript:void(0)">
                            $ USD
                            <span className="ps-1">
                              <i className="fa-regular fa-angle-down"></i>
                            </span>
                          </a>
                          <ul className="it-header-top__area-submenu">
                            <li>
                              <a href="#">Canada</a>
                            </li>
                            <li>
                              <a href="#">Russia</a>
                            </li>
                            <li>
                              <a href="#">Mexico</a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-7 col-xl-8 col-lg-9 col-md-8">
                <div className="it-header-top-content text-center text-md-end">
                  <ul>
                    <li className="d-none d-sm-inline-block">
                      <div>
                        <a href="tel:008757845682">
                          <i className="flaticon-phone-call"></i>{' '}
                          <span className="hover-anim white">
                            (00) 875 784 5682
                          </span>
                        </a>
                      </div>
                    </li>
                    <li>
                      <div>
                        <a href="maito:medicainfo@gmail.com">
                          <i className="flaticon-letter"></i>
                          <span className="hover-anim white">
                            meditoinfo@gmail.com
                          </span>
                        </a>
                      </div>
                    </li>
                    <li className="d-none d-lg-inline-block">
                      <div>
                        <a
                          target="_blank"
                          href="https://www.google.com/maps/@23.9486883,87.4982529,16.83z?entry=ttu"
                        >
                          <i className="flaticon-location"></i>
                          <span className="hover-anim white">
                            238, Arimantab, Moska - USA.
                          </span>
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="header-sticky"
          className={
            isVisible
              ? 'it-header-area it-header-ptb it-header-style-3 it-header-style-6 white-bg header-sticky'
              : 'it-header-area it-header-ptb it-header-style-3 it-header-style-6 white-bg'
          }
        >
          <div className="container">
            <div className="p-relative">
              <div className="row align-items-center">
                <div className="col-xl-2 col-lg-6 col-6">
                  <div className="it-header-logo">
                    <Link to="/">
                      <img src={headerLogo ? headerLogo : Logo} alt="" />
                    </Link>
                  </div>
                </div>
                <div className="col-xl-7 d-none d-xl-block">
                  <div className="it-header-main-menu it-main-menu">
                    <nav className="it-menu-content">
                      {!isOnePage ? (
                        <MenuItems />
                      ) : (
                        <MenuItemsOnePage onePageStyle="onePage4" />
                      )}
                    </nav>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-6">
                  <div className="it-header-button d-flex align-items-center justify-content-end">
                    <Link
                      to="/appointment"
                      className="it-btn-theme grey-bg d-none d-lg-block"
                    >
                      <Button btnText="Book an appointment" />
                    </Link>
                    <div className="it-header-bar d-xl-none">
                      <button
                        className="it-menu-bar"
                        onClick={() => setIsOffCanvasOpen(true)}
                      >
                        <span>
                          <i className="fa-regular fa-bars-sort"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="it-offcanvas-area">
        <div className={isOffCanvasOpen ? 'itoffcanvas opened' : 'itoffcanvas'}>
          <div className="itoffcanvas__close-btn">
            <button
              className="close-btn"
              onClick={() => setIsOffCanvasOpen(false)}
            >
              <i className="fal fa-times"></i>
            </button>
          </div>
          <div className="itoffcanvas__logo">
            <Link to="/">
              <img src={LogoWhite} alt="" />
            </Link>
          </div>
          <div className="itoffcanvas__text">
            <p>
              Suspendisse interdum consectetur libero id. Fermentum leo vel orci
              porta non. Euismod viverra nibh cras pulvinar suspen.
            </p>
          </div>
          <div className="it-menu-mobile">
            {!isOnePage ? (
              <MenuItems isMobileMenu />
            ) : (
              <MenuItemsOnePage onePageStyle="onePage4" isMobileMenu />
            )}
          </div>
          <div className="itoffcanvas__info">
            <h3 className="offcanva-title">Get In Touch</h3>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-envelope"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Email</span>
                <a href="maito:hello@yourmail.com">hello@yourmail.com</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fal fa-phone-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Phone</span>
                <a href="tel:(00)45611227890">(00) 456 1122 7890</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-20 d-flex align-items-center">
              <div className="itoffcanvas__info-icon">
                <a href="#">
                  <i className="fas fa-map-marker-alt"></i>
                </a>
              </div>
              <div className="itoffcanvas__info-address">
                <span>Location</span>
                <a
                  href="htits://www.google.com/maps/@37.4801311,22.8928877,3z"
                  target="_blank"
                >
                  Riverside 255, San Francisco, USA
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isOffCanvasOpen ? (
        <div
          className="body-overlay apply"
          onClick={() => setIsOffCanvasOpen(false)}
        ></div>
      ) : (
        <div className="body-overlay"></div>
      )}
    </>
  );
};

export default HeaderFour;
